import { z } from "zod";

export const sectionResourceStatsDistinctResourcesResultSchema = z.object({
  "ControlSignal.distinctResources": z.string().optional(),
});

export const sectionResourceStatsDistinctResourcesResultArraySchema = z
  .array(sectionResourceStatsDistinctResourcesResultSchema)
  .nullish();

export const sectionResourceStatsResourceCountResultSchema = z.object({
  "ResourceCount.resourceCount": z.string().optional(),
});

export const sectionResourceStatsResourceCountResultArraySchema = z
  .array(sectionResourceStatsResourceCountResultSchema)
  .nullish();

export type SectionResourceStatsDistinctResourcesResult = z.infer<
  typeof sectionResourceStatsDistinctResourcesResultSchema
>;

export type SectionResourceStatsResourceCountResult = z.infer<
  typeof sectionResourceStatsResourceCountResultSchema
>;
